var map = {
	"./Animal1.png": "./src/assets/images/avatars/Animal1.png",
	"./Animal2.png": "./src/assets/images/avatars/Animal2.png",
	"./Animal3.png": "./src/assets/images/avatars/Animal3.png",
	"./Animal4.png": "./src/assets/images/avatars/Animal4.png",
	"./Animal5.png": "./src/assets/images/avatars/Animal5.png",
	"./Animal6.png": "./src/assets/images/avatars/Animal6.png",
	"./Animal7.png": "./src/assets/images/avatars/Animal7.png",
	"./Animal8.png": "./src/assets/images/avatars/Animal8.png",
	"./Animal9.png": "./src/assets/images/avatars/Animal9.png",
	"./Edgy1.png": "./src/assets/images/avatars/Edgy1.png",
	"./Edgy2.png": "./src/assets/images/avatars/Edgy2.png",
	"./Edgy3.png": "./src/assets/images/avatars/Edgy3.png",
	"./Edgy4.png": "./src/assets/images/avatars/Edgy4.png",
	"./Edgy5.png": "./src/assets/images/avatars/Edgy5.png",
	"./Edgy6.png": "./src/assets/images/avatars/Edgy6.png",
	"./Edgy7.png": "./src/assets/images/avatars/Edgy7.png",
	"./Edgy8.png": "./src/assets/images/avatars/Edgy8.png",
	"./Edgy9.png": "./src/assets/images/avatars/Edgy9.png",
	"./Golf1.png": "./src/assets/images/avatars/Golf1.png",
	"./Golf2.png": "./src/assets/images/avatars/Golf2.png",
	"./Golf3.png": "./src/assets/images/avatars/Golf3.png",
	"./Golf4.png": "./src/assets/images/avatars/Golf4.png",
	"./Golf5.png": "./src/assets/images/avatars/Golf5.png",
	"./Golf6.png": "./src/assets/images/avatars/Golf6.png",
	"./Golf7.png": "./src/assets/images/avatars/Golf7.png",
	"./Golf8.png": "./src/assets/images/avatars/Golf8.png",
	"./Golf9.png": "./src/assets/images/avatars/Golf9.png",
	"./Guest.png": "./src/assets/images/avatars/Guest.png",
	"./Mystery.png": "./src/assets/images/avatars/Mystery.png",
	"./Nature1.png": "./src/assets/images/avatars/Nature1.png",
	"./Nature2.png": "./src/assets/images/avatars/Nature2.png",
	"./Nature3.png": "./src/assets/images/avatars/Nature3.png",
	"./Nature4.png": "./src/assets/images/avatars/Nature4.png",
	"./Nature5.png": "./src/assets/images/avatars/Nature5.png",
	"./Nature6.png": "./src/assets/images/avatars/Nature6.png",
	"./Nature7.png": "./src/assets/images/avatars/Nature7.png",
	"./Nature8.png": "./src/assets/images/avatars/Nature8.png",
	"./Nature9.png": "./src/assets/images/avatars/Nature9.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/avatars sync recursive ^\\.\\/.*\\.png$";